import { Icon, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import styled from 'styled-components';
import { r4 } from '@ardoq/design-tokens';
import { DocumentItemViewModel } from '../assistantDocumentsOperations';

const NAME_MAX_WIDTH = 200;

const Thumbnail = styled.img`
  width: ${IconSize.MEDIUM}px;
  height: ${IconSize.MEDIUM}px;
  flex: 0 0 auto;
  object-fit: contain;
  border-radius: ${r4};
`;

const FileName = styled.div`
  min-width: 0;
  max-width: ${NAME_MAX_WIDTH}px;
`;

type DocumentThumbnailProps = {
  item: DocumentItemViewModel;
};

export const DocumentThumbnail = ({ item }: DocumentThumbnailProps) =>
  item.thumbnailUrl ? (
    <Thumbnail src={item.thumbnailUrl} alt={item.name} />
  ) : (
    <Icon iconName={item.icon} />
  );

type DocumentPreviewProps = {
  item: DocumentItemViewModel;
};

export const DocumentPreview = ({ item }: DocumentPreviewProps) => (
  <FlexBox gap="small" align="center">
    <DocumentThumbnail item={item} />
    <FileName>
      <Text variant="text2" truncate>
        {item.name}
      </Text>
    </FileName>
  </FlexBox>
);
